import { Component, OnInit } from '@angular/core';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';

import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Platform } from '@ionic/angular';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { interval, Observable } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import BackgroundGeolocation from 'cordova-background-geolocation-lt';
import { DatePipe } from '@angular/common';
import { Guid } from 'guid-typescript';

@Component({
  selector: 'app-global',
  templateUrl: './global.page.html',
  styleUrls: ['./global.page.scss'],
})
export class GlobalPage implements OnInit {
  public driverAdmin: any;
  public driverName: string;
  public driverSignaturePath: string;
  public employee_ID: number;
  public uaVehicle: any;
  public w2YN: any;
  public altLogin: boolean;
  public authtoken: any;
  public alternateDriverLogin: any;
  public isCancel: any;
  public isnoshow: any;

  public refresh: any;
  public getdate: any;
  public currentdate: any;
  public date: any = new Date();
  public ViewAll: any;
  public vehicle: any = [];
  public signmember: any;
  public offline: boolean;
  public token: any;
  public latitude: any = 0;
  public longitude: any = 0;
  public userID: any;
  public apiKey: any;
  public apiKeyUrl: any;
  public logout: boolean;
  public vanID: any = Guid.EMPTY;
  public localNotifiTitle: any;
  public localNotifiBody: any;
  public gpsTime: any;
  gps: any = [];
  pages: any = [];
  public mustUpdate: boolean;
  public isOffline: boolean;
  public isOfflineChangeByUser: boolean;
  public istripcompletedval: boolean = false;
  uuid: any;
  device_Platform: any;
  model: any;
  device_Manufacture: any;
  device_Serial: any;
  public agencyId: string = "";
  public globalheaderTimeZone: string = "";
  public agencycode: any;
  public selectMemberName: any;
  public SelectTblid: any;

  public memberreason: any;
  public facilityreason: any;
  public IsMemberRefusesToSign: boolean = false;
  public membersign: boolean = false;
  public mfembersign: boolean = false;
  public tblid: any;
  public IsFacilityRefusesToSign: boolean = false;
  public facilitysign: any;
  public Munabletosign: any;
  public MFunabletosign: any;
  public MFcheck: any;
  public facilitysignedcheck: any = false;
  public membersignedcheck: any = false;
  public issign: any;
  public clientage: any;
  public tophysiciancheck: any;
  public memberunabletosign: any;
  public memsignreason: any;
  public facsignreason: any;
  public isFacsignature: any;
  public isMemsignature: any;
  public pagestay: boolean = false;
  public pagestayd: boolean = false;
  public pagestayF: boolean = false;
  public memsignbool: any;
  public facsignbool: any;
  public transid: any;
  public defaultfacility: any;
  public myScheduleTripSignedMemberFacilityYN: any;
  public membername: any;
  public isendwaittime: boolean;
  public leg: any;
  public legstatus: any;

  constructor(private androidPermissions: AndroidPermissions, private platform: Platform,
    private locationAccuracy: LocationAccuracy, public device: Device, private geolocation: Geolocation,
    private storage: Storage, public http: HttpClient, private datePipe: DatePipe) { }

  ngOnInit() {
  }
  Adddata(data): Promise<void> {
    return new Promise((resolve) => {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.globalheaderTimeZone = timeZone; //data.timeZone;
      this.driverAdmin = data.driverAdmin;
      this.driverName = data.driverName;
      this.driverSignaturePath = data.driverSignaturePath;
      this.employee_ID = data.employee_ID != null && data.employee_ID != '' ? data.employee_ID : Guid.EMPTY;
      this.uaVehicle = data.uaVehicle;
      this.w2YN = data.w2YN;
      this.authtoken = data.tocken;
      this.apiKey = data.apiKey;
      this.alternateDriverLogin = data.alternateDriverLogin;
      this.isCancel = data.hasCancelYN;
      this.isnoshow = data.noShow;
      this.refresh = false;
      var currentDate = new Date();
      var d = currentDate.getDate();
      var m = currentDate.getMonth() + 1; //Jan is 0
      var yyyy = currentDate.getFullYear();
      this.getdate = m + '-' + d + '-' + yyyy;
      this.currentdate = m + '-' + d + '-' + yyyy;
      this.ViewAll = false;
      this.vehicle;
      this.signmember = "M";
      this.offline = false;
      this.token;
      this.apiKeyUrl;
      this.logout = false;
      this.vanID;
      this.altLogin;
      this.agencycode = data.dbCode;
      resolve(); // Ensures completion before proceeding
    });
  }
  update(data) {
    this.driverAdmin = data.driverAdmin;
    this.driverName = data.driverName;
    this.driverSignaturePath = data.driverSignaturePath;
    this.employee_ID = data.employee_ID != null && data.employee_ID != '' ? data.employee_ID : Guid.EMPTY;
    this.uaVehicle = data.uaVehicle;
    this.w2YN = data.w2YN;
    this.apiKey = data.apiKey;
    this.alternateDriverLogin = data.alternateDriverLogin;
    this.isCancel = data.hasCancelYN;
    this.isnoshow = data.noShow;
    this.agencycode = data.dbCode;
  }
  getgps() {
    //BackgroundGeolocation.stop();
    // this.geolocation.watchPosition({ enableHighAccuracy: true }).subscribe(resp => {
    //   if (resp.coords) {
    //     if (this.latitude != resp.coords.latitude && this.longitude != resp.coords.longitude) {
    //       this.sendgps();
    //     }
    //     this.latitude = resp.coords.latitude;
    //     this.longitude = resp.coords.longitude;
    //   }
    //   else if (!resp.coords) {
    //     this.latitude = 0;
    //     this.longitude = 0;
    //     this.sendgps();
    //   }
    // })


    this.geolocation.getCurrentPosition({ enableHighAccuracy: true }).then((resp) => {
      this.latitude = resp.coords.latitude;
      this.longitude = resp.coords.longitude;
      this.sendgps();
    }).catch((error) => {
      this.latitude = 0;
      this.longitude = 0;
      this.sendgps();
    });
  }
  sendgps() {
    if (this.latitude == null && this.longitude == null) {
      this.latitude = 0;
      this.longitude = 0;
    }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.globalheaderTimeZone = timeZone;
    if (this.platform.is("android")) {
      this.gps = {
        driverId: this.employee_ID,
        latitude: this.latitude,
        longitude: this.longitude,
        deviceNbr: this.device.uuid,
        deviceSerialNumber: this.device.serial,
        driverName: this.driverName,
        // timezone: this.globalheaderTimeZone,
        // timestamp: this.gpsTime
      }
    }
    else if (this.platform.is("ios")) {
      this.gps = {
        driverId: this.employee_ID,
        latitude: this.latitude,
        longitude: this.longitude,
        deviceNbr: this.device.uuid,
        deviceSerialNumber: this.device.uuid,
        driverName: this.driverName,
        // timezone: this.globalheaderTimeZone,
        // timestamp: this.gpsTime
      }
    }
    this.gps = JSON.stringify(this.gps)
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    console.log(this.gps, 'sendgpsapi', this.device.uuid, this.employee_ID, this.logout);
    if (this.device.uuid != null && this.employee_ID && !this.logout) {
      let url = "api/NearbyVehicle/InsertNearByVehicleDetails";
      this.http.post(url, this.gps, httpOptions).subscribe(
        (data: any) => {
        }
        ,
        err => {
          // console.log(err);
        }
      );
    }
  }
  async AndroidPermission() {
    const ready = !!await this.platform.ready();
    if (ready) {
      this.AppGpsPermission();
    }
  }


  AppGpsPermission() {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION).then(
      result => {
        if (result.hasPermission) {
          this.requestToSwitchOnGPS()

        } else {
          this.askGPSPermission();
        }
      },
      err => {
      }
    );
  }
  requestToSwitchOnGPS() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          (data) => {
            this.getLocationAccCords()
          },
          error => { }
        );
      }
    })

  }
  getLocationAccCords() {
    if (window['myValue']) {
      this.geolocation.getCurrentPosition().then((response) => {
      }).catch((err) => {
        alert('Error: ' + err);
      });
    }
    this.geolocation.getCurrentPosition().then((response) => {
    }).catch((err) => {
      alert('Error: ' + err);
    });
  }
  askGPSPermission() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
      } else {
        this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)
          .then(
            (result) => {
              if (result.hasPermission) {
                this.requestToSwitchOnGPS();
              }
            },
            error => {
              this.requestToSwitchOnGPS();
              // alert(error)
            }
          );
      }
    });
  }

  // async backgroundGPS() {
  //   // console.log('function call')
  //   BackgroundGeolocation.start();
  //   await BackgroundGeolocation.ready({
  //     // desiredAccuracy: 1,
  //     stationaryRadius: 2,
  //     distanceFilter: 3,
  //     debug: false,
  //     // fastestLocationUpdateInterval: 30000,
  //     foregroundService: true,
  //     // geofenceModeHighAccuracy: true,
  //     // locationAuthorizationRequest: "Any",
  //     // locationUpdateInterval: 30000,
  //     // preventSuspend: true,
  //     // startOnBoot: true,
  //     stopOnTerminate: true,
  //     locationAuthorizationRequest: 'Always',
  //     notification: {
  //       // sticky: true,
  //       title: "AllTrans GPS Tracking",
  //       text: "Live Location Sharing",
  //       // priority: BackgroundGeolocation.NOTIFICATION_PRIORITY_MIN,
  //       // smallIcon: "mipmap/ic_notification",
  //     },
  //     backgroundPermissionRationale: {
  //       title: "Allow AllTrans to access to this device's location in the background?",
  //       message: "In order to track your activity in the background, please enable Allow all the time location permission",
  //     }
  //   }).then((state) => {
  //   })
  //   // .catch(error =>{
  //   //   this.backgroundGPS();
  //   // });

  //   BackgroundGeolocation.getCurrentPosition({
  //     timeout: 30
  //   }).then((location) => {
  //     console.log(location, 'location')
  //     this.latitude = location.coords.latitude
  //     this.longitude = location.coords.longitude
  //     if (this.gpsTime != location.timestamp) {
  //       if (this.platform.is('android') || this.platform.is('ios')) {
  //         this.sendgps();
  //         // console.log('sendgps')
  //       }
  //     }
  //     this.gpsTime = location.timestamp;
  //   })
  //   // .catch(error => {
  //   //   this.backgroundGPS();
  //   // })
  // }

  /////////----TO REQUEST ENABLE LOCATION------------////////////
  locationenable() {
    // if (this.platform.is("android")) {
    let loc = new Promise((resolve) => {
      this.locationAccuracy.canRequest().then((canRequest: boolean) => {
        if (canRequest) {
          // the accuracy option will be ignored by iOS
          this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
            () => {
              // Observable.interval(10000).subscribe(() => {
              // this.backgroundMode.disableWebViewOptimizations();
              if (!this.offline) {
                this.storage.get("loginAuth").then((val) => {
                  if (val && !this.logout) {
                    if (window['myValue']) {
                      // this.backgroundGPS();
                    }
                    else {
                      this.getgps();
                    }
                  }
                })
              }

              // });
              // Observable.interval(30000).subscribe(() => {
              //   this.checkHighAccuracy();
              // });
              // resolve();
            },
            error => { return }
          );
        } else {
          return
        }
      }).catch((err) => {
        return
      });
    });
    return loc
    // }
    // else if (this.platform.is("ios")) {
    //   Observable.interval(10000).subscribe(() => {
    //     if (!this.offline) {
    //       this.nativeStorage.getItem("loginAuth").then((val) => {
    //         if (val && !this.logout) {
    //this.backgroundGPS();
    //         }
    //       })
    //     }
    //   });
    //   Observable.interval(30000).subscribe(() => {
    //     this.checkHighAccuracy();
    //   });
    // }
  }

  checkHighAccuracy() {
    let loc = new Promise((resolve) => {
      this.locationAccuracy.canRequest().then((canRequest: boolean) => {
        if (canRequest) {
          // the accuracy option will be ignored by iOS
          this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
            () => {
              // resolve();
            },
            error => { return }
          );
        } else {
          return
        }
      }).catch((err) => {
        return
      });
    });
    return loc
  }

  getDateTimeString(date: any): string {
    var tzoffset = (new Date(date)).getTimezoneOffset() * 60000; //offset in milliseconds
    return (new Date(new Date(date).getTime() - tzoffset)).toISOString();
  }

  getDateTimeString1(date: any): string {
    let datess = this.datePipe.transform(new Date(date), 'yyyy-MM-dd HH:mm:ss')
    return (new Date(datess)).toISOString();
  }

  // Formating Only Date
  getFormatingDate(Date: string) {
    const dateParts = Date?.split('-');
    const month = dateParts[0];
    const day = dateParts[1];
    const year = dateParts[2];
    let formatDate;
    if (year?.length == 4) {
      formatDate = `${year}-${month}-${day}`;
    } else {
      formatDate = this.datePipe.transform(Date, 'yyyy-MM-dd')
    }
    return this.datePipe.transform(formatDate, 'yyyy-MM-dd')!;
  }

  // getFormatCurrentDate(Date) {
  //   return this.datePipe.transform(Date, 'yyyy-MM-dd')
  // }
// In GlobalPage
getFormatCurrentDate(dateValue: string | Date): string | null {
  if (!dateValue) return null;
  return this.datePipe.transform(dateValue, 'yyyy-MM-dd');
}

  requestPushPermission() {
    if (this.platform.is('android')) {
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.POST_NOTIFICATIONS).then(
        (result) => {
          if (!result.hasPermission) {
            // Request permission from the user
            this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.POST_NOTIFICATIONS).then(
              () => {
                console.log('Push notification permission granted.');
              },
              (err) => {
                console.error('Push notification permission denied', err);
              }
            );
          } else {
            console.log('Push notification permission already granted.');
          }
        },
        (err) => {
          console.error('Permission check failed', err);
        }
      );
    } else {
    }
  }

}
